import LoadingComponent from '@/components/loading'
import { app } from '@beastshop/browser'
import bridge from '@beastshop/bridge'
let $vm
// let _resolve
// let _reject

(function () {
  function install (Vue) {
    const Loading = Vue.extend(LoadingComponent)
    let showLoading = (flag) => {
      if(app()){
        bridge.showLoading()
        return
      }
      if (!$vm) {
        $vm = new Loading({
          el: document.createElement('div')
          // propsData: {
          //   mshow: true
          // }
        })
        document.body.appendChild($vm.$el)
      }
      $vm.white = flag ? true : false
      $vm.mshow = true
      $vm.$on('loading-hide', function(msg) {
        $vm.mshow = false
      })
      // return new Promise((resolve) => {
      //   _resolve = resolve
      // })
    }

    let hideLoading = () => {
      if(app()){
        return bridge.hideLoading()
      }
      $vm && $vm.$emit('loading-hide');
    }

    Vue.mixin({
      created: function () {
        this.$showLoading = showLoading
        this.$hideLoading = hideLoading
      }
    })
  }

  if (typeof exports == "object") {
    module.exports = install
  } else if (typeof define == "function" && define.amd) {
    define([], function(){ return install })
  } else if (window.Vue) {
    Vue.use(install)
  }

})()



// WEBPACK FOOTER //
// ./static/plugins/loading/index.js